import styled from "@emotion/styled";
import { TypedSearchResultDataValue } from "./../utils";
import { Tag, tagClasses } from "@kaltura/ds-react-components";
import { baseUrl } from "@kaltura/mediaspace-shared-utils";
import { useContext } from "react";
import { ConfigContext } from "@kaltura/mediaspace-shared-data-kms-config";

export interface TagSearchResultProps {
    data: TypedSearchResultDataValue;
    masterKey: string;
}

const StyledTagSearchResult = styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    columnGap: theme.spacing(0.5),
    rowGap: theme.spacing(1),
    padding: theme.spacing(0.5, 0),
}));

const StyledTag = styled(Tag)(({ theme }) => ({
    [`&.${tagClasses.root}`]: {
        color: theme.kaltura.palette.tone2,
    },
    [`& .${tagClasses.label}`]: {
        paddingLeft: 6,
        paddingRight: 6,
    },
}));

export function TagSearchResult({ data, masterKey }: TagSearchResultProps) {
    const configContext = useContext(ConfigContext);
    const isKaf = configContext.application?.isKAF;

    return (
        <StyledTagSearchResult>
            {data.items // data will definitely have items, that's how we wrap tags
                && data.items.map((tagItem, index) => (
                    <StyledTag
                        label={tagItem.text}
                        href={`${baseUrl}/tag?tagid=${tagItem.text}`}
                        key={`${masterKey}_${index}`}
                        component={isKaf ? undefined : "a"}
                    />
                ))}
        </StyledTagSearchResult>
    );
}

export default TagSearchResult;
